var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutgoingServer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0697 3.44444L14.0608 3.44444M5.53633 6.11111L3.403 6.11111C2.57466 6.11111 2.16049 6.11111 1.83378 5.97578C1.39818 5.79535 1.05209 5.44926 0.871654 5.01366C0.736329 4.68695 0.736329 4.27278 0.736329 3.44444C0.736329 2.6161 0.73633 2.20193 0.871655 1.87523C1.05209 1.43962 1.39818 1.09354 1.83378 0.913102C2.16049 0.777777 2.57466 0.777776 3.403 0.777777L14.0697 0.777777C14.898 0.777778 15.3122 0.777778 15.6389 0.913103C16.0745 1.09354 16.4206 1.43962 16.601 1.87523C16.7363 2.20193 16.7363 2.6161 16.7363 3.44444C16.7363 4.27279 16.7363 4.68696 16.601 5.01366C16.4206 5.44926 16.0745 5.79535 15.6389 5.97579C15.3122 6.11111 14.898 6.11111 14.0697 6.11111L11.9363 6.11111M8.73633 5.22222L8.73633 15M8.73633 15L6.06966 12.3333M8.73633 15L11.403 12.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutgoingServer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outgoingServer.e72374234c955e600f26a0f0cc00d7a2.svg";